import { render, staticRenderFns } from "./Personalization.vue?vue&type=template&id=2fd514f0&"
import script from "./Personalization.vue?vue&type=script&lang=js&"
export * from "./Personalization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports